// Note: ApiProperty is backend-specific (NestJS/Swagger)
// It's generally better to omit backend-framework-specific decorators
// from common types packages. Define them where they are used (e.g., in the controller).

export class SignUpReportRowDto {
  // @ApiProperty({ description: 'User ID' })
  userId: string;

  // @ApiProperty({ description: 'Username (alias)' })
  username: string;

  // @ApiProperty({ description: 'User first name' })
  firstName: string;

  // @ApiProperty({ description: 'User last name' })
  lastName: string;

  // @ApiProperty({ description: 'User sign-up date' })
  signUpDate: Date;

  // @ApiProperty({ description: 'Total amount deposited by the user' })
  depositTotal: number;

  // @ApiProperty({ description: 'Total rake generated by the user' })
  rakeGenerated: number;

  // @ApiProperty({ description: 'Date of the user\'s last login', nullable: true })
  lastLoginDate: Date | null;

  // @ApiProperty({ description: 'Referral code the user signed up with', nullable: true })
  referralCode: string | null;

  // @ApiProperty({ description: 'Inbound source if available (e.g., facebook, direct)', nullable: true })
  inboundSource: string | null;
}
